import { connect } from 'react-redux';

// Component
import Router from './Router';

const mapStateToProps = store => {
  return {
    store,
  };
};

export default connect(mapStateToProps, {})(Router);
